// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import FooterComponent from '../components/global/footer'
import NavbarComponent from '../components/global/navbar'
import URL from '../constants/urls'
import About from '../pages/about/About'
import Contact from '../pages/contact'
import Main from '../pages/main'
import Pass from '../pages/pass'
import CreatePass from '../pages/passPurchase/main/CreatePass'
import SignUp from '../pages/signup'
import ThankYou from '../pages/thankyou'
import PaymentFails from '../pages/thankyou/PaymentFails'
import UserProfile from '../pages/user/profile/UserProfile'
import VehicleDemo from '../pages/user/vehicleDemo/VehicleDemo'
import Confirmation from '../pages/passPurchase/confirmation/Confirmation'
import Navigating from '../pages/user/MasqueradeUserLogin'
import HomeComponent from '../pages/bookingPortal/home/homeComponent'
import PaymentResponse from '../pages/bookingPortal/pass/paymentResponse'
import PassComponent from '../pages/bookingPortal/pass/passComponent'
import PaymentFailed from '../pages/bookingPortal/pass/paymentFailed'
import FailedComponent from '../pages/bookingPortal/pass/failedComponent'
import DirectBookingResponse from '../pages/bookingPortal/pass/directBookingResponse'
import ConfirmationComponent from '../pages/bookingPortal/pass/confirmationComponent'
import Ticket from '../pages/eTicketRecipt/Ticket'
import { toast, ToastContainer } from 'react-toastify'
import { getLoggedUserData } from '../utils/HelperEvent'
import { getPartnerDetails, isPartnerTownsend, isPathValid, isPermissionExist, sortPortalPermissionByKey } from '../utils/helper'
import Login from '../pages/home/Login'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/globalConstants'
import usePathDetector from '../Hooks/pathChangeDetector'
import SendEmailResetPassword from '../components/global/SendEmailResetPassword'
import ForgotPassword from '../components/global/ForgotPassword'
import ResponsiveReservation from '../pages/responsiveReservation/responsiveReservation'
import { getPartnerDetailsBySLug } from '../redux/actions/partnerAction'
import NotFound from '../pages/bookingPortal/not-found/error-404'
import LoadingScreen from '../pages/bookingPortal/not-found/loading'
import BookingEdit from '../pages/user/bookingHistory/BookingEdit'
import BookingCancel from '../pages/bookingCancel/bookingCancel'
import BookingSMS from '../pages/bookingCancel/bookingSMS'
import { errorMessage } from '../constants/errorMessage'
// import ResponsivePemitRequest from '../pages/monthlyPermitRequest/monthlyPermitRequest'
import SearchTicket from '../pages/eTicketRecipt/searchTicket'
import ResponsivePemitRequest from '../pages/permitRequest/main'
import PaymentPemitRequest from '../pages/paymentPermitRequest/paymentPermitRequest'
// import TransientForm from '../pages/warningCitation_old'
import TransientForm from '../pages/warningCitation/pages/transientForm/TransientForm'
import PaymentResponseWarn from '../pages/warningCitation/pages/paymentReposnse/PaymentResponse'
import ExtendFormNew from '../pages/warningCitation/pages/ExtendFeatureForm/ExtendFormNew'
import ExtendResponse from '../pages/warningCitation/pages/ExtendFeatureForm/ExtendResponse'
import ScanAutoValidationQr from '../pages/warningCitation/components/global/ScanAutoValidationQr'
import DraggableButton from '../components/global/DraggableButton'
import { getConfigDetails } from '../services/config'
import ComingSoon from '../components/ComingSoon'
import FindReservation from '../pages/responsiveReservation/FindReservation'
import PassDetails from '../pages/passDetails/PassDetails'




function RoutesComponent(props) {
	const { dispatch } = props
	let path = window.location.toString().includes('iframe') ? window.location.toString().split('/')[4] : window.location.toString().split('/')[3]
	// const facility = window.location.toString().split('/')[4]
	const [isOpened, setIsOpened] = useState(false)
	const [isNavigating, setIsNavigating] = useState(false)
	// const [isThisPathValid, setIsPathValid] = useState(false)
	const [routeDetecting, setRouteDetecting] = useState(0)
	const [partnerDetails, setPartnerDetails] = useState(EMPTY_OBJECT)
	const [faviconPath, setFaviconPath] = useState('')
	const [title, setTitle] = useState('')
	const [isPortalPermissionAvailable, setIsPortalPermissionAvailable] = useState(true)
	const [isComingSoon, setIsComingSoon] = useState(false)
	const urlParams = window.location.toString().split('/')
	const [loading, setLoading] = useState(true)
	const [isDataUpdate, setDataUpdate] = useState(false)
	const [mainMenu, setMainMenu] = useState(EMPTY_OBJECT)
	const isMasquerade = localStorage.getItem('masquerade')

	useEffect(() => {
		if (localStorage.getItem('partnerData') == undefined || localStorage.getItem('partnerData') == 'undefined') {
			localStorage.removeItem('partnerData')
			sessionStorage.removeItem('partnerData')
		}
		// Listen for changes in localStorage
		window.addEventListener('storage', (event) => {
			if (event.key === 'partnerData') {
				sessionStorage.setItem('dataUpdated', 'true')
			}
		})

		// Check for updates when the tab becomes active
		document.addEventListener('visibilitychange', () => {
			if (document.visibilityState === 'visible' && sessionStorage.getItem('dataUpdated') === 'true') {
				const updatedData = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : null
				if ((path != 'events' && path != 'navigating' && ((updatedData?.slug != '' && updatedData?.slug != null && path != updatedData?.slug) || (updatedData?.partner_slug != '' && updatedData?.partner_slug != null && path != updatedData?.partner_slug))) || !updatedData) {
					setDataUpdate(true)
				} else {
					setDataUpdate(false)
				}
				sessionStorage.removeItem('dataUpdated')
			}
		})

		localStorage.getItem('partnerData') == 'undefined' || localStorage.getItem('partnerData') == undefined ? localStorage.removeItem('partnerData') : null
		let partnerDate = localStorage.getItem('partnerData') != 'undefined' ? JSON.parse(localStorage.getItem('partnerData')) : {}
		if (path?.toLowerCase() !== partnerDate?.slug?.toLowerCase() && path?.toLowerCase() !== partnerDate?.partner_slug?.toLowerCase()
		) {
			handleLogout()
		}
	}, [EMPTY_ARRAY, path])

	window.addEventListener('click', function () {
		setIsOpened(false)
	})

	const handleLogout = () => {
		localStorage.removeItem('userData')
		localStorage.removeItem('isLoggedIn')
		localStorage.removeItem('masquerade')

		if (getPartnerDetails()) {
			sessionStorage.setItem('partnerSecret', getConfigDetails()?.CLIENT_SECRET)
			sessionStorage.setItem('partnerData', JSON.stringify(getPartnerDetails()))
		}
		localStorage.removeItem('partnerSecret')
		sessionStorage.removeItem('partnerSecret')
		localStorage.removeItem('partnerData')
		sessionStorage.removeItem('partnerData')
		sessionStorage.removeItem('partnerSecret')
		localStorage.clear()
	}

	const isPathChanged = usePathDetector()

	const handlePartnerData = (data) => {
		setLoading(false)
		localStorage.setItem('partnerData', JSON.stringify(data))
		const partnerData = data
		const hasPortalAccess = isPermissionExist(sortPortalPermissionByKey(partnerData, 'Access Permissions'), 'Customer Portal Access')
		setIsPortalPermissionAvailable(hasPortalAccess)
		const issetComingSoon = isPermissionExist(sortPortalPermissionByKey(partnerData, 'Restricted Permissions'), 'Enable Coming Soon')
		setIsComingSoon(issetComingSoon)

		const menu = sortPortalPermissionByKey(partnerData, 'Main Menu')
		setMainMenu(menu)
		setPartnerDetails(data)
		setTitle(data?.brand_setting?.name ? data?.brand_setting?.name : data?.company_name ? data?.company_name : 'Customer Portal')
		setFaviconPath(data?.brand_setting ? data?.brand_setting?.faviconurl ? data?.brand_setting?.faviconurl : data?.brand_setting?.logourl ? data?.brand_setting?.logourl : data?.partner_details?.brand_setting?.logourl : data?.partner_details?.brand_setting?.logourl)
		if (partnerData) {
			let color = partnerData?.brand_setting ? partnerData?.brand_setting?.color : partnerData?.partner_details?.brand_setting?.color
			let rgb = partnerData?.brand_setting ? JSON.parse(partnerData?.brand_setting?.rgb_color) : JSON.parse(partnerData?.partner_details?.brand_setting?.rgb_color)
			if (color) {
				document.documentElement.style.setProperty('--bs-primary', color)
				document.documentElement.style.setProperty('base-color', color)
				document.documentElement.style.setProperty('primary', color)
				document.documentElement.style.setProperty('textcolor', color)
				document.documentElement.style.setProperty('--bs-btn-bg', color)
				document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
				document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
				document.documentElement.style.setProperty('--bs-list-group-active-color', color)
				document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
			}
		}
	}

	useEffect(() => {
		if (path == '' || path == null || path == undefined) {
			if (window?.location?.toString()?.includes('rev-pass')) {
				path == 'revpass'
				window.location.href = window?.location?.toString() + 'revpass'
			}
		}
		if (path && path != 'events') {
			let apiSlug
			if (path != 'navigating') {
				apiSlug = path
			} else {
				apiSlug = urlParams[urlParams?.length - 1]
			}
			setLoading(true)
			localStorage.removeItem('partnerData')
			sessionStorage.removeItem('partnerData')
			let tries = 0
			dispatch(getPartnerDetailsBySLug(apiSlug)).then((res) => {
				if (res?.data && res?.data?.brand_setting != null) {
					handlePartnerData(res?.data)
				} else {
					if (tries == 0) {
						tries = 1
						dispatch(getPartnerDetailsBySLug(apiSlug)).then((res) => {
							if (res?.data && res?.data?.brand_setting != null) {
								handlePartnerData(res?.data)
							} else {
								setLoading(false)
								notify('error', res && res?.errors ? res?.errors?.message : res?.data?.brand_setting == null ? errorMessage?.brand_settings_missing : errorMessage?.somethingWentWrong)
							}
						}).catch((err) => {
							setLoading(false)
							notify('error', err ? err?.message : errorMessage?.somethingWentWrong)
						})
					} else {
						setLoading(false)
						notify('error', res && res?.errors ? res?.errors?.message : errorMessage?.somethingWentWrong)
					}
				}
			}).catch((err) => {
				if (tries == 0) {
					tries = 1
					dispatch(getPartnerDetailsBySLug(apiSlug)).then((res) => {
						if (res?.data && res?.data?.brand_setting != null) {
							handlePartnerData(res?.data)
						} else {
							setLoading(false)
							notify('error', res && res?.errors ? res?.errors?.message : res?.data?.brand_setting == null ? errorMessage?.brand_settings_missing : errorMessage?.somethingWentWrong)
						}
					}).catch((err) => {
						setLoading(false)
						notify('error', err ? err?.message : errorMessage?.somethingWentWrong)
					})
				} else {
					setLoading(false)
					notify('error', err ? err?.message : errorMessage?.somethingWentWrong)
				}

			})
		} else if (path != 'navigating') {
			setLoading(false)
			localStorage.removeItem('partnerSecret')
			sessionStorage.removeItem('partnerSecret')
		} else {
			setLoading(false)
			localStorage.removeItem('partnerSecret')
			sessionStorage.removeItem('partnerSecret')
		}
	}, [path])

	useEffect(() => {
		const updateFavicon = () => {
			const favicon = document.querySelector('link[rel="icon"]')
			favicon.href = faviconPath
		}

		const updateTitle = () => {
			document.title = title
		}

		const updateMetaTag = (property, content) => {
			let metaTag = document.querySelector(`meta[property="${property}"]`)
			if (!metaTag) {
				metaTag = document.createElement('meta')
				metaTag.setAttribute('property', property)
				document.head.appendChild(metaTag)
			}
			metaTag.setAttribute('content', content)
		}

		updateMetaTag('og:title', title)
		updateMetaTag('og:description', title)
		updateMetaTag('og:image', faviconPath)

		updateFavicon()
		updateTitle()
	}, [faviconPath, title])

	useEffect(() => {
		if (path == 'navigating') {
			setIsNavigating(false)
		} else {
			setIsNavigating(true)
		}
		const partnerData = getPartnerDetails()
		const color = partnerData?.brand_setting?.color
		if (partnerData?.brand_setting && partnerData?.brand_setting?.color) {
			document.documentElement.style.setProperty('--bs-primary', color)
			document.documentElement.style.setProperty('base-color', color)
			document.documentElement.style.setProperty('primary', color)
			document.documentElement.style.setProperty('textcolor', color)
			document.documentElement.style.setProperty('--bs-btn-bg', color)
			document.documentElement.style.setProperty('--bs-primary-rgb', '34, 32, 93')
			document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
			document.documentElement.style.setProperty('--bs-list-group-active-color', color)
			document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
		}
	}, [EMPTY_ARRAY, isPathChanged])

	const notify = (type, message) => {
		toast.dismiss()
		if (type === 'error') {
			toast.error(message, {
				position: toast.POSITION.TOP_RIGHT
			})
		} else if (type === 'success') {
			toast.success(message, {
				position: toast.POSITION.TOP_RIGHT
			})
		}
	}

	const renderHomeComponent = () => {
		const hasLoginAccess = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access')
		const firstElem = mainMenu?.[0]?.display_name

		// Display Reservation
		if (firstElem == 'Reservation') {
			return <ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
		} else if (firstElem == 'Permit Request') {
			return <ResponsivePemitRequest notify={notify} partnerDetails={partnerDetails} />
		} else if (firstElem == 'Permit Purchase') { //Display Main
			return <Main notify={notify} partnerDetails={partnerDetails} />
		} else if (firstElem == 'Pass Purchase') { //Display Pass
			return <CreatePass notify={notify} partnerDetails={partnerDetails} />
		} else if (firstElem == 'Booking') { //Booking
			return getLoggedUserData()?.access_token ? <PassComponent /> : <HomeComponent />
		} else if (hasLoginAccess) { //Display Login
			return <Login notify={notify} />
		} else { //Display Not Found
			return <LoadingScreen notify={notify} />
		}

	}
	const handleStopMasquerading = () => {
		localStorage.removeItem('masquerade')
		window.location.href = `${window.location.host.includes('localhost') ? getConfigDetails()?.adminLocalUrl : window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revadminUrl : getConfigDetails().adminUrl}/admin/user-management`
	}
	return (
		<BrowserRouter forceRefresh className="mt-3" basename="/">
			{loading || window.location.toString().includes('iframe') ? null : <NavbarComponent isOpened={isOpened} setIsOpened={setIsOpened} notify={notify} partnerDetails={partnerDetails} setRouteDetecting={setRouteDetecting} routeDetecting={routeDetecting} />}
			<div className="flex-grow-1 d-flex flex-column">
				{loading ? <LoadingScreen notify={notify} /> :
					(isPortalPermissionAvailable && isPathValid(mainMenu, urlParams[window.location.toString().includes('iframe') ? 5 : 4]) && Object.values(partnerDetails).length != 0) ?
						isComingSoon ? <Routes>
							<Route
								path={'*'}
								element={<ComingSoon notify={notify} partnerDetails={partnerDetails} />}
							/>
						</Routes>
							:
							<Routes>
								<Route
									path={URL.HOME}
									element={renderHomeComponent()}
								/>
								<Route
									path={URL.FACILITY_HOME}
									element={renderHomeComponent()}
								/>
								<Route
									path={URL.IFRAME_HOME}
									element={renderHomeComponent()}
								/>
								<Route
									path={URL.IFRAME_FACILITY_HOME}
									element={renderHomeComponent()}
								/>
								<Route
									path={URL.PROMOTION}
									element={renderHomeComponent()}
								/>
								<Route
									path={URL.PERMITPURCHASE}
									element={<Main notify={notify} partnerDetails={partnerDetails} />}
								/>
								<Route
									path={URL.FACILITY_PERMITPURCHASE}
									element={<Main notify={notify} partnerDetails={partnerDetails} />}
								/>
								<Route
									path={URL.SEND_EMAIL_FORGOT_PASSWORD}
									element={
										<SendEmailResetPassword notify={notify} />
									}
								/>
								<Route
									path={URL.FORFOT_PASSWORD}
									element={
										<ForgotPassword notify={notify} />
									}
								/>
								<Route
									path={URL.THANKYOU}
									element={
										<ThankYou notify={notify} />
									}
								/>
								<Route
									path={URL.ABOUT}
									element={
										<About />
									}
								/>
								<Route
									path={URL.SIGNUP}
									element={
										<SignUp />
									}
								/>
								<Route
									path={URL.LOGIN}
									element={
										<Login notify={notify} />
									}
								/>

								<Route
									path={URL.PASS_DETAILS}
									element={
										<PassDetails notify={notify} partnerDetails={partnerDetails} />
									}
								/>

								<Route
									path={URL.PASS}
									element={
										<Pass />
									}
								/>
								<Route
									path={URL.PASSCREATE}
									element={
										<CreatePass notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.CONTACT}
									element={
										<Contact />
									}
								/>
								<Route
									path={URL.USER}
									element={
										<VehicleDemo notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.USER_PROFILE}
									element={
										<UserProfile notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.PAYMENT_SUCCESS}
									element={
										<ThankYou notify={notify} />
									}
								/>
								<Route
									path={URL.PAYMENT_FAIL}
									element={
										<PaymentFails />
									}
								/>
								<Route
									path={URL.PASS_PAYMENT_SUCCESS}
									element={
										<Confirmation />
									}
								/>
								<Route
									path={URL.PASS_PAYMENT_FAIL}
									element={
										<Confirmation />
									}
								/>
								<Route
									path={URL.NAVIGATING}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.NAVIGATING_RECEIPT}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.NAVIGATING_PARTNER}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.GUEST_NAVIGATING}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.USER_NAVIGATING_PERMIT}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.NAVIGATING_MASQUERADE_PARTNER}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.USER_NAVIGATING_MASQUERADE_PERMIT}
									element={
										<Navigating />
									}
								/>
								<Route
									path={URL.BOOKTICKET}
									element={
										getLoggedUserData()?.access_token ? <PassComponent /> : <HomeComponent />
									}
								/>
								<Route
									path={URL.CHECKOUT_PASSES}
									element={
										<PassComponent />
									}
								/>
								<Route
									path={URL.AAA_PAYMENT_RESPONSE}
									element={
										<PaymentResponse />
									}
								/>
								<Route
									path={URL.AAA_FAILED_COMPONENT}
									element={
										<PaymentFailed />
									}
								/>
								<Route
									path={URL.AAA_PAYMENT_SUCCESS}
									element={
										<ConfirmationComponent />
									}
								/>
								<Route
									path={URL.AAA_PAYMENT_FAILED}
									element={
										<FailedComponent />
									}
								/>
								<Route
									path={URL.AAA_BOOKING_RESPONSE}
									element={
										<DirectBookingResponse />
									}
								/>

								<Route
									path={URL.TICKET}
									element={
										<Ticket notify={notify} />
									}
								/>
								<Route
									path={URL.CANCELRESERVATION}
									element={
										<BookingCancel notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.IFRAME_CANCELRESERVATION}
									element={
										<BookingCancel notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route path={URL.SMSRESERVATION} element={<BookingSMS notify={notify} partnerDetails={partnerDetails} />} />
								<Route
									path={URL.RESPONSIVE_RESERVATION}
									element={
										<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.RESPONSIVE_RESERVATION_FACILITY}
									element={
										<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								{/* EOS-740 */}
								<Route
									path={URL.FIND_RESERVATION}
									element={
										<FindReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.IFRAME_FIND_RESERVATION}
									element={
										<FindReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								{/* EOS-740 */}

								<Route
									path={URL.IFRAME_RESPONSIVE_RESERVATION}
									element={
										<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.IFRAME_RESPONSIVE_RESERVATION_FACILITY}
									element={
										<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
									}
								/>
								<Route
									path={URL.RESPONSIVE_PERMIT_REQUEST}
									element={
										<ResponsivePemitRequest notify={notify} partnerDetails={partnerDetails} />
									}
								/>

								<Route
									path={URL.PAYMENT_PERMIT_REQUEST}
									element={
										<PaymentPemitRequest notify={notify} partnerDetails={partnerDetails} />
									}
								/>

								{/* for the Booking Edit */}
								<Route path={URL.BOOKING_EDIT} element={<BookingEdit notify={notify} partnerDetails={partnerDetails} />} />
								<Route path={URL.IFRAME_BOOKING_EDIT} element={<BookingEdit notify={notify} partnerDetails={partnerDetails} />} />
								{/* end booking Edit Routes */}

								<Route
									path={URL.TICKET_VIEW}
									element={
										<SearchTicket notify={notify} />
									}
								/>
								<Route
									path={URL.TICKET}
									element={
										<Ticket notify={notify} />
									}
								/>
								{/* 2 */}
								<Route path="*" element={
									(window?.location?.toString()?.includes('rev-pass') && (window.location.toString().split('/')[3] == '' || window.location.toString().split('/')[3] == undefined || window.location.toString().split('/')[3] == null)) ? <LoadingScreen notify={notify} /> : <NotFound />
								}>

								</Route>
							</Routes>
						:
						<Routes>

							<Route
								path={URL.NAVIGATING}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.NAVIGATING_RECEIPT}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.NAVIGATING_PARTNER}
								element={
									<Navigating />
								}
							/>

							<Route
								path={URL.GUEST_NAVIGATING}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.USER_NAVIGATING_PERMIT}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.NAVIGATING_MASQUERADE_PARTNER}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.USER_NAVIGATING_MASQUERADE_PERMIT}
								element={
									<Navigating />
								}
							/>
							<Route
								path={URL.HOME}
								element={
									renderHomeComponent()
								}
							/>
							<Route
								path={URL.USER}
								element={
									renderHomeComponent()
								}
							/>
							<Route
								path={URL.USER_PROFILE}
								element={
									<LoadingScreen />
								}
							/>
							<Route
								path={URL.SEND_EMAIL_FORGOT_PASSWORD}
								element={
									<SendEmailResetPassword notify={notify} />
								}
							/>
							<Route
								path={URL.FORFOT_PASSWORD}
								element={
									<ForgotPassword notify={notify} />
								}
							/>
							<Route
								path={URL.PAYMENT_PERMIT_REQUEST}
								element={
									<PaymentPemitRequest notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							{/* for the Booking Edit */}
							<Route path={URL.BOOKING_EDIT} element={<BookingEdit notify={notify} partnerDetails={partnerDetails} />} />
							<Route path={URL.IFRAME_BOOKING_EDIT} element={<BookingEdit notify={notify} partnerDetails={partnerDetails} />} />
							<Route path={URL.CANCELRESERVATION} element={<BookingCancel notify={notify} partnerDetails={partnerDetails} />} />
							<Route path={URL.IFRAME_CANCELRESERVATION} element={<BookingCancel notify={notify} partnerDetails={partnerDetails} />} />
							<Route path={URL.SMSRESERVATION} element={<BookingSMS notify={notify} partnerDetails={partnerDetails} />} />
							<Route path={URL.IFRAME_SMSRESERVATION} element={<BookingSMS notify={notify} partnerDetails={partnerDetails} />} />

							<Route
								path={URL.PASS_DETAILS}
								element={
									<PassDetails notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							<Route
								path={URL.HOME2}
								element={
									<TransientForm notify={notify} partnerDetails={partnerDetails} />
								}
							/>

							<Route
								path={URL.WARNING_OR_CITATION_URL}
								element={
									<TransientForm notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							<Route
								path={URL.CONFIRMATION_SCREEN}
								element={
									<PaymentResponseWarn notify={notify} />
								}
							/>
							<Route
								path={URL.TICKET_EXTEND}
								element={
									<ExtendFormNew notify={notify} partnerDetails={partnerDetails} />
								} />
							<Route
								path={URL.EXTEND_SUCCESS}
								element={
									<ExtendResponse notify={notify} />
								}
							/>
							<Route
								path={URL.SCAN_TOKEN_VALIDATE}
								element={
									<ScanAutoValidationQr notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							{/* <Route
					path={URL.RESPONSIVE_PERMIT_REQUEST}
					element={
						<ResponsivePemitRequest notify={notify} partnerDetails={partnerDetails} />
					}
				/> */}
							<Route
								path={URL.TESTURL}
								element={renderHomeComponent()}
							/>

							<Route
								path={URL.RESPONSIVE_RESERVATION}
								element={
									<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							<Route
								path={URL.IFRAME_RESPONSIVE_RESERVATION}
								element={
									<ResponsiveReservation notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							{/* EOS-740 */}
							<Route
								path={URL.FIND_RESERVATION}
								element={
									<FindReservation notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							<Route
								path={URL.IFRAME_FIND_RESERVATION}
								element={
									<FindReservation notify={notify} partnerDetails={partnerDetails} />
								}
							/>
							{/* EOS-740 */}

							{/* end booking Edit Routes 1 */}
							<Route path='*'
								element={
									(window?.location?.toString()?.includes('rev-pass') && (window.location.toString().split('/')[3] == '' || window.location.toString().split('/')[3] == undefined || window.location.toString().split('/')[3] == null)) ? <LoadingScreen notify={notify} /> : <NotFound />
								}
							/>
						</Routes>
				}
			</div>
			{loading || window.location.toString().includes('iframe') ? null : (!isPartnerTownsend(path) && isNavigating) ? <FooterComponent /> : null}
			<ToastContainer limit={2} newestOnTop={true}
				closeOnClick />
			{isDataUpdate && (
				<div className="popup-overlay">
					<div className="popup-content">
						<p>{errorMessage?.awayMessage}</p>
						<div className="text-end">
							<button
								type="button"
								className="btn bg-primary text-white"
								onClick={() => window.location.reload()}
							>
								Refresh
							</button>
						</div>
					</div>
				</div>
			)}
			{isMasquerade && <DraggableButton
				handleStopMasquerade={handleStopMasquerading}
			/>}
		</BrowserRouter>
	)
}

RoutesComponent.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool,
}

RoutesComponent.defaulProps = {
	dispatch: noop,
	isFetching: false

}

function mapStateToProps({ PartnerReducer }) {
	return {

		isFetching: PartnerReducer?.isFetching,
	}
}
export default connect(mapStateToProps)(RoutesComponent)
